import type { ColorValueHex } from "types/styled";

export const WHITE = "#FFFFFF";

type ColorScale = {
  [key: number]: ColorValueHex;
};

export const BLUE: ColorScale = {
  5: "#F9FBFE",
  10: "#EDF4FC",
  15: "#E4EFFB",
  20: "#DCEAFA",
  30: "#CADFF8",
  40: "#A7CAF3",
  50: "#A7CAF3",
  60: "#96C0F1",
  70: "#84B5EE",
  80: "#73ABED",
  90: "#61A0EA",
  100: "#307FE2",
};

export const DARK_BLUE: ColorScale = {
  1: "#F7F8FB",
  5: "#F5F8FC",
  10: "#E8EFF7",
  20: "#E1E8EF",
  30: "#D4DBE2",
  40: "#B0BBC8",
  50: "#8D9BAD",
  60: "#6F7F93",
  70: "#536479",
  80: "#3C4C60",
  90: "#273546",
  100: "#17222F",
};

export const GREEN: ColorScale = {
  10: "#EDF9F1",
  20: "#DCF3E4",
  30: "#CAEDD6",
  40: "#B9E8C9",
  50: "#A7E2BB",
  60: "#8BD2A3",
  70: "#7CCE98",
  80: "#6DCB8D",
  90: "#61CA85",
  100: "#4FC577",
};

export const ORANGE: ColorScale = {
  10: "#FFF6ED",
  20: "#FEEEDA",
  30: "#FEE5C8",
  40: "#FDDDB6",
  50: "#FDD4A3",
  60: "#FDCB91",
  70: "#FCC37F",
  80: "#FCBA6D",
  90: "#FBB25A",
  100: "#FBA948",
};

export const PURPLE: ColorScale = {
  10: "#F0EEFB",
  20: "#E1DDF8",
  30: "#D1CBF5",
  40: "#C2BAF1",
  50: "#B3A9ED",
  60: "#A498EA",
  70: "#9587E7",
  80: "#8575E3",
  90: "#7664E0",
  100: "#6753DC",
};

export const RED: ColorScale = {
  10: "#FEEEEB",
  20: "#FCDDD8",
  30: "#FBCBC4",
  40: "#F9BAB0",
  50: "#F8A99C",
  60: "#F79889",
  70: "#F58775",
  80: "#F47561",
  90: "#F2644E",
  100: "#F1533A",
};

export const TEAL: ColorScale = {
  10: "#E8FAF9",
  20: "#D0F5F3",
  30: "#B9F1ED",
  40: "#A1ECE7",
  50: "#8AE7E1",
  60: "#72E2DC",
  70: "#5BDED6",
  80: "#44D9D0",
  90: "#2CD4CA",
  100: "#15CFC4",
};

export const YELLOW: ColorScale = {
  10: "#FEFCED",
  20: "#FEF8DB",
  30: "#FDF5C9",
  40: "#FDF1B7",
  50: "#FCEEA5",
  60: "#FBEB94",
  70: "#FBE782",
  80: "#FAE470",
  90: "#FAE05E",
  100: "#F9DD4C",
};
